import React from 'react'
import { Box, ClickAwayListener, Typography, useTheme } from '@mui/material'
import { components } from 'react-select'
import StateIcon from 'components/global/StateIcon'

export const DropdownIndicator = ({ ...props }) => {
  const theme = useTheme()
  return (
    <Box mr={1}>
      {props.selectProps.menuIsOpen ? (
        <StateIcon iconlabel={'angle-up'} iconweight={'regular'} iconcolor={theme.palette.primary.main} />
      ) : (
        <StateIcon iconweight={'regular'} iconlabel={'angle-down'} iconcolor={theme.palette.grey[500]} />
      )}
    </Box>
  )
}

export const ValueContainer = ({ ...props }) => {
  const theme = useTheme()
  const selectedValue = props.getValue()[0]

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <components.ValueContainer {...props}>
      <Box>
        <Typography
          sx={{
            color: '#464646',
            fontSize: '12px',
            paddingLeft: theme.spacing(1.5),
            fontWeight: 400
          }}
        >
          {!selectedValue
            ? props.selectProps.placeholder
            : selectedValue.label}
        </Typography>
      </Box>
    </components.ValueContainer>
  )
}

export const CustomOption = ({ isSelected, label, ...props }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        backgroundColor: isSelected
          ? theme.palette.grey[100]
          : theme.palette.common.white,
        border: '1px solid transparent',
        borderRadius: '4px',
        '&:hover': {
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: '4px',
        },
        padding: theme.spacing(0.5, 1),
        margin: theme.spacing(1),
        cursor: 'pointer',
      }}
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <components.Option {...props}>
        <Typography
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: 500,
            fontSize: 12,
            lineHeight: 2,
            color: isSelected
              ? theme.palette.grey[600]
              : theme.palette.grey[500],
          }}
        >
          {label}
        </Typography>
      </components.Option>
    </Box>
  )
}

export const CustomControl = ({ children, ...props }) => {
  const { menuIsOpen, onMenuClose, onMenuOpen } = props.selectProps
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <components.Control {...props}>
      <ClickAwayListener
        mouseEvent="onMouseDown"
        onClickAway={() => {
          onMenuClose()
        }}
      >
        <Box
          onClick={() => {
            if (menuIsOpen) {
              onMenuClose()
            } else {
              onMenuOpen()
            }
          }}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexGrow: 1,
            cursor: 'pointer',
            height: '100%',
            width: '100%'
          }}
        >
          {children}
        </Box>
      </ClickAwayListener>
    </components.Control>
  )
}

export const getSelectStyles = (theme, isSmall = false) => ({
  container: (base) => ({
    ...base,
    width: isSmall ? '100%' : '220px',
    height: '32px'
  }),
  control: (base) => ({
    ...base,
    border: '1px solid #EFEFEF',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#EFEFEF'
    },
    borderRadius: '8px',
    minHeight: '32px',
    height: '32px',
    padding: '0 0 0 4px',
    color: '#464646',
    fontSize: '12px',
    fontWeight: 400
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0',
    margin: '0',
    height: '100%'
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1500,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 1500,
  }),
  option: (base) => ({
    ...base,
    backgroundColor: 'transparent',
    padding: '0',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: 'transparent',
      outline: 'none',
      boxShadow: 'none'
    }
  })
})
